import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import SectionHeading from './SectionHeading';
import TradeDashboard from './TradeDashboard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp'; // better trading vibe

const TradesSection = () => {
  return (
    <Box component="section" id="trades" sx={{ py: 8 }}>
      <Container>
        <SectionHeading 
          title="Trade Dashboard" 
          subtitle="Track our trading bot's performance with real-time active positions and historical results."
        />

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', mb: 6, mt: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <TrendingUpIcon color="primary" sx={{ fontSize: 36, mr: 1 }} />
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
              Global Performance Overview
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', maxWidth: 500 }}>
            A live summary of our bot’s trading results, across all markets and timeframes.
          </Typography>
        </Box>

        <TradeDashboard />
      </Container>
    </Box>
  );
};

export default TradesSection;
